import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import type React from 'react';

import InvoiceZeroSvg from 'assets/illustrations/Invoice-Paid-Amount-1.svg';

import { useStyles } from '../styles';

export default function RecordInvoicePaymentDialogContent(): React.JSX.Element {
  const { classes } = useStyles();

  return (
    <Box className={classes.dialogContent}>
      <Box>
        <img src={InvoiceZeroSvg} alt='Invoice Illustration' className={classes.dialogIllustration} />
      </Box>
      <Box className={classes.dialogContentTextWrapper}>
        <Typography variant='titleMedium'>You got paid!</Typography>
        <Typography variant='bodyRegular'>
          Let&apos;s get this applied to your invoice to mark it as paid and reduce the amount in your accounts
          receivable account.
        </Typography>
      </Box>
    </Box>
  );
}
